import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import appDisplay from 'scoreboard/components/app-display'
import BusyButton from 'scoreboard/components/busy-button'
import formHelper from 'scoreboard/components/form-helper'
import globals from 'scoreboard/components/globals'
import i18n from 'scoreboard/components/i18n'
import PublishAlertConfirmation from './publish-alert-confirmation'
import template from './publish-alert-form.hbs'

/**
 * A dialog to allow the user to enter a message for
 * recipients and send a published alert.
 */
const PublishAlertForm = Backbone.View.extend({

	tagName: 'form',

	className: 'panel publish-alert-form',

	events: {
		'submit': 'submit'
	},

	/**
	 * @param {String} options.domainTypeLabel
	 * @param options.subscription.domainId
	 * @param options.subscription.domainType
	 * @param options.subscription.type
	 * @param options.recipientCount
	 */
	initialize(options = {}) {
		this.options = options
		this.subscription = this.options.subscription
	},

	render: function () {
		const {recipientCount, domainTypeLabel} = this.options
		this.$el.empty().append(template({domainTypeLabel}))
		this.$('.banner').text(i18n.countMessage('alerts.publish.changes.description',
			recipientCount, domainTypeLabel, recipientCount))
		this.publishButton = new BusyButton({el: this.$('.button-primary')})

		return this
	},

	submit(e) {
		e && e.preventDefault()
		this.$el.addClass('is-submitting-form') // Doesn't use formView so add class manually
		this.publishButton.loading()
		const {domainTypeLabel} = this.options
		return $.ajax({
			method: 'post',
			url: `api/alerts/subscriptions/domains/${this.subscription.domainId}/publish?periodId=${globals.periodId}`,
			data: JSON.stringify(_.extend(formHelper.readFromDom(this.el), this.subscription)),
			success: () => {
				this.trigger('done')
				appDisplay.dialog(new PublishAlertConfirmation({
					recipientCount: this.options.recipientCount,
					domainTypeLabel
				}))
			}
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.publishButton], 'remove')
	}

})

export default PublishAlertForm
PublishAlertForm.__filename__ = 'alerts/publish-alert-form.js'
